<!-- 产品详情 -->
<template>
  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">{{ detail.productsTitle }}</div>
    </div>

    <div class="display_flex productBox">
      <OssImg class="productImg" :src="detail.productsHeaderOssUrl" alt="" />
      <div
        class="info"
        v-html="
          detail.productsRemark
            ?.replace(/\。/g, '。<br/>')
            .replace(/\/n/g, '<br/>')
        "
      ></div>
    </div>
    <div
      class="imageBox"
    >
      <OssImg :src="item" class="imageItem" alt="" 
      v-for="(item, index) in detail.productsOssUrl" 
      :key="index"/>
    </div>

    <div class="title" style="text-align: center">
      <div class="text1">产品参数</div>
    </div>
    <div class="display_flex infoBox">
      <!-- <OssImg class="infoImg" :src="detail.productsHeaderOssUrl" alt="" /> -->
      <div class="richTextCl" v-html="detail.productsDetail"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import ProductApi from "@/api/productApi";
import OssImg from "@/components/ossImg.vue";
import { processRichTextImages } from "@/utils/hanldeRichText";
const productApi = new ProductApi();
const route = useRoute();
const id = ref(0);
const detail = ref({});

onMounted(() => {
  id.value = route.query.id;
  getDetail(id.value);
  addProductBrower(id.value);
});

const getDetail = async (id) => {
  console.log("id-----------", id);
  let res = await productApi.getProductDetail({ id });
  let productsOssUrl = res.data.productsOssUrl;
  detail.value = res.data;
  detail.value.productsOssUrl = productsOssUrl?productsOssUrl.split(",") : [];
  detail.value.productsDetail = await processRichTextImages(
    detail.value.productsDetail
  );
};

/**
 * 产品浏览量增加
 */
const addProductBrower = async (id) => {
  await productApi.addProductBrowse(id);
};
</script>

<style lang="scss" scoped>
.productBox {
  .productImg {
    width: 50% !important;
    height: 100%;
    height: 500px;
    object-fit: contain;
  }

  .info {
    width: 50%;
    padding: 3rem;
    color: #424242;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 2.5rem;
    flex-shrink: 0;
  }
}

.infoBox {
  width: 100%;
  .infoImg {
    width: 50% !important;
    height: 100%;
    height: 500px;
    margin-right: 2rem;
  }

  div {
    width:70%;
  }
}

.imageBox {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  // display: grid;
  // grid-template-columns: repeat(3, 1fr);
  // grid-gap: 1rem;

  .imageItem {
    width: 100%;
    height: 34.375rem;
    object-fit: contain;
  }
}
</style>
